import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { utilitiesMap } from '../../utils/billsFeaturesAdapter';

import './ListingBillsItem.scss';

const ROOM_PROPERTY_TYPES = ['room_shared_apt', 'room_residence'];

const getNameFromListingType = listingType =>
  ROOM_PROPERTY_TYPES.includes(listingType) ? trans('listing.bills.room') : '';

const getAdditionalInfoFormated = additionalInfo =>
  typeof additionalInfo === 'number' ? additionalInfo / 100 : additionalInfo;

const getPricingMessages = (
  pricingValue,
  { listingType, currency, additionalInfo }
) => {
  const listingTypeName = getNameFromListingType(listingType);
  const additionalInfoFormatted = getAdditionalInfoFormated(additionalInfo);

  const includedWithAmountSubtext = listingTypeName
    ? trans('listing.bills.amount-included', {
        billAmount: additionalInfoFormatted,
        currency,
        type: listingTypeName
      })
    : trans('listing.bills.amount-included-no-type', {
        billAmount: additionalInfoFormatted,
        currency
      });

  const notIncludedWithAmountSubtext = listingTypeName
    ? trans('listing.bills.amount-is-not-included', {
        billAmount: additionalInfoFormatted,
        currency,
        type: listingTypeName
      })
    : trans('listing.bills.amount-is-not-included-no-type', {
        billAmount: additionalInfoFormatted,
        currency
      });

  const notIncludedWithEstimationSubtext =
    additionalInfoFormatted === null
      ? trans('listing.bills.estimation-requested-to-landlord')
      : trans('listing.bills.amount-estimated', {
          billAmount: additionalInfoFormatted,
          currency,
          type: listingTypeName
        });

  const pricingMap = {
    included: {
      text: trans('listing.bills.is-included'),
      subtext: ''
    },
    includedWithLimit: {
      text: trans('listing.bills.is-included'),
      subtext: includedWithAmountSubtext
    },
    includedWithGlobalLimit: {
      text: trans('listing.bills.is-included'),
      subtext: includedWithAmountSubtext
    },
    payToLandlord: {
      text: trans('listing.bills.is-not-included'),
      subtext: notIncludedWithEstimationSubtext
    },
    payToLandlordFixed: {
      text: trans('listing.bills.is-not-included'),
      subtext: notIncludedWithAmountSubtext
    },
    payToLandlordFixedGlobal: {
      text: trans('listing.bills.is-not-included'),
      subtext: notIncludedWithAmountSubtext
    },
    payToLandlordUponInvoice: {
      text: trans('listing.bills.is-not-included'),
      subtext: notIncludedWithEstimationSubtext
    },
    payToProvider: {
      text: trans('listing.bills.is-not-included'),
      subtext: notIncludedWithEstimationSubtext
    },
    payToProviderUponInvoice: {
      text: trans('listing.bills.is-not-included'),
      subtext: notIncludedWithEstimationSubtext
    },
    dontKnow: {
      text: trans('listing.bill.no-info-available'),
      subtext: ''
    },
    noGas: {
      text: trans('listing.bills.no_gas'),
      subtext: ''
    },
    noInternet: {
      text: trans('listing.bills.no_internet'),
      subtext: ''
    }
  };
  return pricingMap[pricingValue];
};

const ListingBillsItem = ({ bill, listingType, currency }) => {
  const { key, value, additionalInfo } = bill;
  const keysArray = Array.isArray(key) ? key : [key];
  const pricingMessages = getPricingMessages(value, {
    listingType,
    currency,
    additionalInfo
  });

  return (
    <div className="listing-bills-item">
      <div className="listing-bills-item__section-wrapper">
        <div className="listing-bills-item__title-wrapper">
          {keysArray.map(utilityKey => {
            const { title } = utilitiesMap[utilityKey];
            return (
              <div className="listing-bills-item__title" key={title}>
                {trans(title)}
              </div>
            );
          })}
        </div>
        <div className="listing-bills-item__value-wrapper">
          <div className="listing-bills-item__value">
            {pricingMessages.text}
          </div>
          <div className="listing-bills-item__value-subtitle">
            {pricingMessages.subtext}
          </div>
        </div>
      </div>
    </div>
  );
};

ListingBillsItem.propTypes = {
  currency: PropTypes.string.isRequired,
  listingType: PropTypes.string.isRequired,
  bill: PropTypes.object.isRequired
};

export default ListingBillsItem;
